export default __webpack_public_path__ + "static/media/8bio-wt.3edf074c.png";